import { render, staticRenderFns } from "./receive_card.vue?vue&type=template&id=6d4b6874&"
import script from "./receive_card.vue?vue&type=script&lang=js&"
export * from "./receive_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports